import script from "./CompanyProfileApp.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProfileApp.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProfileApp.vue?vue&type=style&index=0&id=415f239b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415f239b"]])

export default __exports__